module.exports = __webpack_public_path__ + "img/03.362c377f.jpeg";